function initFileInputs() {
	$('body').on('click', '.js-reset-file', function(e){
		let fileInput = $(this).parents('.file-input').find('input[type=file]');
		fileInput.val(null);
		fileInput.siblings('.js-file-input-value').html('');
		fileInput.trigger('change');
		fileInput.trigger('blur');
		e.preventDefault();
	});

	$('input[type=file]').off().on('change', function (e) {
		//skip if input button is from ask a question or case detail page, as it is handled differently
		if (this.getAttribute('id') !== "upload-photo" && this.getAttribute('id') !== "upload-file-file") {
			var $value = $(this).closest('.file-input').find('.js-file-input-value');
			var $this = $(this);
			if (((this) as any).files && ((this) as any).files[0]) {
				if ($this.data("accept")) {
					let fileAssocArray = $this.data("accept").split(',');
					let fileName = ((this) as any).files[0].name;
					let fileExt = (fileName.split(/[. ]+/).pop()).toLowerCase();
					if (fileAssocArray.indexOf(`.${fileExt}`) > -1) {
						$value.html(((this) as any).files[0].name);
						$value.append('<i class="icon icon-times file-input-close js-reset-file text-blue-bright" title="Remove Image"></i>')
					} else {
						alert(`.${fileExt} files are not allowed. Please choose one of the following file types: (${fileAssocArray})`);
					}
				} else {
					$value.html(((this) as any).files[0].name);
					$value.append('<i class="icon icon-times file-input-close js-reset-file text-blue-bright" title="Remove Image"></i>')
				}
			} else {
				$value.html('');
			}
		}
	});
}

export function init() {
	initFileInputs();
}

export function reset() {
	$('input[type=file]').each(function() {
		$(this).val(null);
		$(this).siblings('.js-file-input-value').html('');
	});
}

export function fileAtIndex(fileInput: HTMLInputElement, index: number): File | null {
	if (index == null || index < 0) return null;
	if (fileInput == null || fileInput.files == null) return null;

	return fileInput.files[index];
}
